import * as React from 'react'

import { Participant } from 'types/Participants'
import BlockParticipant from 'components/Participants/ParticipantActions/Block'
import SendActivationMail from 'components/Participants/ParticipantActions/SendActivationMail'
import ViewParticipant from 'components/Participants/ParticipantActions/View'

export const getParticipantActions = (
  participant: Participant,
): JSX.Element[] => {
  if (participant.confirmed)
    return [
      <BlockParticipant key="block-participant" participant={participant} />,
      <ViewParticipant key="view-participant" participantID={participant.id} />,
    ]

  return [
    <SendActivationMail
      key="send-activation-mail"
      participantID={participant.id}
    />,
    <ViewParticipant key="view-participant" participantID={participant.id} />,
  ]
}
